import { HospitalizationFollowUpProcessingStatus } from '@act/shared/data-transfer-objects';
import { memberHospitalizationFollowUpCompleted } from 'redux/slices/memberSlice.slice';

/** Redux dispatch accepting member follow-up actions. */
type MemberFollowUpDispatch = (
  action: ReturnType<typeof memberHospitalizationFollowUpCompleted>
) => void;

/**
 * Applies portal member state updates after a call follow-up save.
 * @param status Follow-up processing status from the update-call API.
 * @param memberId Member user id when follow-up was requested.
 * @param dispatch Redux dispatch for member slice updates.
 */
export function handleHospitalizationFollowUpCallSaveResult(
  status: HospitalizationFollowUpProcessingStatus | undefined,
  memberId: string | undefined,
  dispatch: MemberFollowUpDispatch
): void {
  if (!memberId || !status || status === 'not_requested') {
    return;
  }

  if (status === 'associated' || status === 'already_linked') {
    dispatch(memberHospitalizationFollowUpCompleted({ memberId }));
  }
}
